/**
 * message-validator.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Observable, Subject } from "rxjs/Rx";
import { Connection } from "../connection/connection";
import {
    ConnectionFailureMessage,
    Message,
    MessageTag,
    Tagged,
    ValidatingClass
} from "../messages/general/";
import { INCOMING_MESSAGE_MAP } from "./incoming-message-map";

export class MessageValidator extends Connection<Message> {
    public incoming : Subject<Message> = new Subject<Message>();

    public constructor (private connection : Connection<any>)
    {
        super();

        // While it would be much simpler to provide the upstream's `incoming`
        // directly as our observable (after being mapped through validation),
        // that would mean every subscription would re-run the validation on
        // the objects it received, which is silly. So instead we "shield" it
        // all behind a Subject that we re-emit our validated messages from.
        // Hence the `new Subject()` above and the `.subscribe` below.
        this.connection.incoming.map(
            (json : any) => this.validate(json)
        ).catch((err : any, caught : Observable<Message>) => {
            if (err instanceof ConnectionFailureMessage)
            {
                throw err;
            }
            else
            {
                console.error("skipping message due to validation error:", err);
                return caught;
            }
        }).subscribe(this.incoming);
    }

    private localDead : boolean = false;
    public get dead () : boolean
    {
        return this.connection.dead || this.localDead;
    }
    public set dead (value : boolean)
    {
        this.localDead = value;
    }

    public validate (json : any) : Message
    {
        if (typeof json !== "object" || json === null)
        {
            console.error("non-object", json);
            throw new Error("Received non-object on incoming stream");
        }
        if (!Number.isInteger(json.tag))
        {
            console.error("non-integer or missing tag", json);
            throw new Error("Received message does not have an integer 'tag'");
        }
        return this.validateTagged(json);
    }

    public validateTagged (json : Tagged) : Message
    {
        const messageClass : ValidatingClass =
            INCOMING_MESSAGE_MAP.get(json.tag);
        if (messageClass === undefined)
        {
            console.error("no validator found", json);
            // throw new Error(`No validator registered for tag ${json.tag}`);
            return json as Message;
        }
        try
        {
            return new messageClass(json);
        }
        catch (err)
        {
            console.error(err, json);
            throw err;
        }
    }

    public close () : void
    {
        this.connection.close();
    }

    public send (message : Message) : void
    {
        this.connection.send(message);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/validation/message-validator.ts